import React, { memo } from 'react';
export function Manifesto() {
  return <section className="bg-[#0a0a0a] py-12 sm:py-20 px-6 relative" data-id="element-141">
      <div className="max-w-3xl mx-auto text-center flex flex-col gap-6 sm:gap-10" data-id="element-142">
        {/* Main paragraph — gold/amber italic serif, slightly bolder */}
        <p className="font-serif italic text-[#d4a85a] text-xl sm:text-2xl lg:text-[26px] leading-[1.6] font-medium" data-id="element-143">
          There are stories the world prefers to ignore. Stories of mothers who
          saw their children leave, never knowing if they would return. Of
          families separated by thousands of miles. Of a nation that was
          snatched from its people in silence, while the rest of the world
          looked the other way.
        </p>

        {/* Second paragraph — white serif, lighter weight */}
        <p className="font-serif text-[#e8e2d4] text-lg sm:text-xl leading-[1.6] font-light" data-id="element-144">
          This book exists because those stories deserve to be told. Because
          memory is the only territory that no one can take away from us.
        </p>
      </div>

      {/* Gold-to-red gradient separator */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 h-px w-3/4 max-w-2xl bg-gradient-to-r from-transparent via-[#d4a85a] to-[#DC2626]" data-id="element-145" />
    </section>;
}